import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./i18n";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// ─── Google Translate React Crash Workaround ──────────────────────────────
// Google Translate mutates React-controlled DOM nodes, causing React to throw
// a fatal "NotFoundError" during rendering, resulting in a blank white screen.
// This patch safely intercepts and ignores these invalid parent-child mutations.
if (typeof window !== "undefined") {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      return child; // Prevent crash by ignoring DOM removal mismatch
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode; // Prevent crash by ignoring DOM insertion mismatch
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
